import { useEffect, useRef, useState } from "react";
import { formatNumber } from "@/lib/api";

/**
 * Animate a number from 0 to `value` over `duration` ms whenever `value` changes.
 * Uses eased quart-out so the count feels celebratory.
 */
export const AnimatedNumber = ({ value = 0, duration = 1400, format = formatNumber, testId }) => {
    const [display, setDisplay] = useState(0);
    const startRef = useRef(null);
    const fromRef = useRef(0);

    useEffect(() => {
        if (value == null || Number.isNaN(value)) return;
        fromRef.current = display;
        startRef.current = null;
        let raf;
        const step = (t) => {
            if (startRef.current == null) startRef.current = t;
            const p = Math.min(1, (t - startRef.current) / duration);
            const eased = 1 - Math.pow(1 - p, 4);
            const next = fromRef.current + (value - fromRef.current) * eased;
            setDisplay(next);
            if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
        return () => cancelAnimationFrame(raf);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, duration]);

    return <span data-testid={testId}>{format(Math.round(display))}</span>;
};

export default AnimatedNumber;
